import React from 'react'
import '../salad_part/SaladPart.css'
import { Col, Container, Row } from 'react-bootstrap'
const SaladPart = () => {
  return (
    <>
        
    <section id="salad_part">
        <Container>
            <Row style={{rowGap: '40px'}}>
                <Col xs={6} lg={4} sm={6} md={6}>
                    <div class="salad_inner">
                        <div class="salad_inner_img">
                            <img src="imeges/salad.png"  class="w-100" alt="salad photo"/>
                        </div>
                        <div class="salad_inner_text">
                            <div class="salad_inner_main">
                             <h5>16<br/>02</h5>
                            </div>
                            <div class="salad_inner_main_text">
                                <h5>Green Onion Knife and salad placed</h5>
                                <p>Nulla quis lorem ut libero malesuada feugiat. Nulla quis lorem ut libero malesuada feugiat. </p>
                                <a href="#"> read more <i class="fa-solid fa-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col xs={6} lg={4} sm={6} md={6}>
                    <div class="salad_inner">
                        <div class="salad_inner_img">
                            <img src="imeges/salad 1.png" class="w-100" alt="salad photo"/>
                        </div>
                        <div class="salad_inner_text">
                            <div class="salad_inner_main">
                             <h5>16<br/>02</h5>
                            </div>
                            <div class="salad_inner_main_text">
                                <h5>Green Onion Knife and salad placed</h5>
                                <p>Nulla quis lorem ut libero malesuada feugiat. Nulla quis lorem ut libero malesuada feugiat. </p>
                                <a href="#"> read more <i class="fa-solid fa-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col xs={6} lg={4} sm={6} md={6}>
                    <div class="salad_inner">
                        <div class="salad_inner_img">
                            <img src="imeges/salad 2.png" class="w-100" alt="salad photo"/>
                        </div>
                        <div class="salad_inner_text">
                            <div class="salad_inner_main">
                             <h5>16<br/>02</h5>
                            </div>
                            <div class="salad_inner_main_text">
                                <h5>Green Onion Knife and salad placed</h5>
                                <p>Nulla quis lorem ut libero malesuada feugiat. Nulla quis lorem ut libero malesuada feugiat. </p>
                                <a href="#"> read more <i class="fa-solid fa-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    </section>
    </>
  )
}

export default SaladPart



